/** The Beeline mark: the arrow, small. Inline SVG so it costs no request and inherits colour. */

const SVG_NS = 'http://www.w3.org/2000/svg';

export function markLogo(size = 44): SVGSVGElement {
  const svg = document.createElementNS(SVG_NS, 'svg');
  svg.setAttribute('viewBox', '0 0 48 48');
  svg.setAttribute('width', String(size));
  svg.setAttribute('height', String(size));
  svg.setAttribute('class', 'mark');
  svg.setAttribute('role', 'img');
  svg.setAttribute('aria-label', 'Beeline');

  const gradient = document.createElementNS(SVG_NS, 'linearGradient');
  gradient.setAttribute('id', 'mark-amber');
  gradient.setAttribute('x1', '0');
  gradient.setAttribute('y1', '0');
  gradient.setAttribute('x2', '0');
  gradient.setAttribute('y2', '1');
  for (const [offset, color] of [
    ['0', '#FFB454'],
    ['1', '#FF8A3D'],
  ] as const) {
    const stop = document.createElementNS(SVG_NS, 'stop');
    stop.setAttribute('offset', offset);
    stop.setAttribute('stop-color', color);
    gradient.appendChild(stop);
  }

  const defs = document.createElementNS(SVG_NS, 'defs');
  defs.appendChild(gradient);

  const ring = document.createElementNS(SVG_NS, 'circle');
  ring.setAttribute('cx', '24');
  ring.setAttribute('cy', '24');
  ring.setAttribute('r', '21');
  ring.setAttribute('fill', 'none');
  ring.setAttribute('stroke', 'currentColor');
  ring.setAttribute('stroke-opacity', '0.25');
  ring.setAttribute('stroke-width', '2');

  const arrow = document.createElementNS(SVG_NS, 'path');
  arrow.setAttribute('d', 'M24 8 L36 38 L24 31 L12 38 Z');
  arrow.setAttribute('fill', 'url(#mark-amber)');

  svg.append(defs, ring, arrow);
  return svg;
}
